import * as ambassadorWixAchievementsCategoriesV3Category from './achievements-categories-v3-category-categories.http.js';
import * as ambassadorWixAchievementsCategoriesV3CategoryTypes from './achievements-categories-v3-category-categories.types.js';
import * as ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes from './achievements-categories-v3-category-categories.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCategory(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.CreateCategoryRequest,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.CreateCategoryRequest,
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.CreateCategoryResponse,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.CreateCategoryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAchievementsCategoriesV3Category.createCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/categories',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateCategory(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.BulkCreateCategoryRequest,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.BulkCreateCategoryRequest,
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.BulkCreateCategoryResponse,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.BulkCreateCategoryResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAchievementsCategoriesV3Category.bulkCreateCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/bulk/categories/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCategory(): __PublicMethodMetaInfo<
  'GET',
  { categoryId: string },
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.GetCategoryRequest,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.GetCategoryRequest,
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.GetCategoryResponse,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.GetCategoryResponse
> {
  const payload = { categoryId: ':categoryId' } as any;

  const getRequestOptions =
    ambassadorWixAchievementsCategoriesV3Category.getCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/categories/{categoryId}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listCategories(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.ListCategoriesRequest,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.ListCategoriesRequest,
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.ListCategoriesResponse,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.ListCategoriesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAchievementsCategoriesV3Category.listCategories(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/categories',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCategory(): __PublicMethodMetaInfo<
  'PATCH',
  { categoryId: string },
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.UpdateCategoryRequest,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.UpdateCategoryRequest,
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.UpdateCategoryResponse,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.UpdateCategoryResponse
> {
  const payload = { category: { id: ':categoryId' } } as any;

  const getRequestOptions =
    ambassadorWixAchievementsCategoriesV3Category.updateCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/categories/{category.id}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCategory(): __PublicMethodMetaInfo<
  'DELETE',
  { categoryId: string },
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.DeleteCategoryRequest,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.DeleteCategoryRequest,
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.DeleteCategoryResponse,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.DeleteCategoryResponse
> {
  const payload = { categoryId: ':categoryId' } as any;

  const getRequestOptions =
    ambassadorWixAchievementsCategoriesV3Category.deleteCategory(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/categories/{categoryId}',
    pathParams: { categoryId: 'categoryId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCategories(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.QueryCategoriesRequest,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.QueryCategoriesRequest,
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.QueryCategoriesResponse,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.QueryCategoriesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAchievementsCategoriesV3Category.queryCategories(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/categories/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkAssignCategoriesToProgram(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.BulkAssignCategoriesToProgramRequest,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.BulkAssignCategoriesToProgramRequest,
  ambassadorWixAchievementsCategoriesV3CategoryUniversalTypes.BulkAssignCategoriesToProgramResponse,
  ambassadorWixAchievementsCategoriesV3CategoryTypes.BulkAssignCategoriesToProgramResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAchievementsCategoriesV3Category.bulkAssignCategoriesToProgram(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/categories/bulk-assign-to-program',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Category as CategoryOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  CategoriesAssignedToProgram as CategoriesAssignedToProgramOriginal,
  CategoryAssignedProgramsUpdated as CategoryAssignedProgramsUpdatedOriginal,
  CreateCategoryRequest as CreateCategoryRequestOriginal,
  CreateCategoryResponse as CreateCategoryResponseOriginal,
  BulkCreateCategoryRequest as BulkCreateCategoryRequestOriginal,
  BulkCreateCategoryResponse as BulkCreateCategoryResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkCategoryResult as BulkCategoryResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  GetCategoryRequest as GetCategoryRequestOriginal,
  GetCategoryResponse as GetCategoryResponseOriginal,
  ListCategoriesRequest as ListCategoriesRequestOriginal,
  ListCategoriesResponse as ListCategoriesResponseOriginal,
  UpdateCategoryRequest as UpdateCategoryRequestOriginal,
  UpdateCategoryResponse as UpdateCategoryResponseOriginal,
  DeleteCategoryRequest as DeleteCategoryRequestOriginal,
  DeleteCategoryResponse as DeleteCategoryResponseOriginal,
  QueryCategoriesRequest as QueryCategoriesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryCategoriesResponse as QueryCategoriesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkAssignCategoriesToProgramRequest as BulkAssignCategoriesToProgramRequestOriginal,
  BulkAssignCategoriesToProgramResponse as BulkAssignCategoriesToProgramResponseOriginal,
  Action as ActionOriginal,
  ActionWithLiterals as ActionWithLiteralsOriginal,
  BulkAssignCategoryResult as BulkAssignCategoryResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './achievements-categories-v3-category-categories.types.js';
